import React from 'react';
import { Progress } from 'reactstrap';
import { StepCircle } from './step-circle';

export const StepProgress = ({ currentStep = 1 }) => {
    const isStep1Completed = currentStep > 1;
    const isStep2Completed = currentStep > 2;
    const isStep3Completed = currentStep > 3;

    return (
        <div className="step-progress-container">
            <div className="d-md-block d-none">
                <StepCircle
                    step={1}
                    isActive={currentStep >= 1}
                    isCompleted={isStep1Completed}
                    label={'Complete the answers'}
                    alignLeft={true}
                />
            </div>
            <div className="d-md-none d-sm-block">
                <StepCircle
                    step={1}
                    isActive={currentStep >= 1}
                    isCompleted={isStep1Completed}
                    label={'Complete the answers'}
                />
            </div>

            <Progress
                key={'mp-step-progress-1'}
                value={currentStep > 1 ? 1 : 0}
                max={1}
                className='flex-fill progress-sm mx-2'
            />

            <StepCircle
                step={2}
                isActive={currentStep >= 2}
                isCompleted={isStep2Completed}
                label={'Review your results'}
            />

            <Progress
                key={'mp-step-progress-2'}
                value={currentStep > 2 ? 1 : 0}
                max={1}
                className='flex-fill progress-sm mx-2'
            />

            <StepCircle
                step={3}
                isActive={currentStep >= 3}
                isCompleted={isStep3Completed}
                label={'Finish'}
            />
        </div>
    )
}